import React from 'react';
import { FallbackProps } from 'react-error-boundary';

export const ErrorBoundaryFallback = ({ error }: ErrorBoundaryFallbackProps) => (
  <div>{error.message}</div>
);

interface ErrorBoundaryFallbackProps extends FallbackProps {}

